document.addEventListener('DOMContentLoaded', () => {
  // 1. DOM references
  const buyNowBtn = document.querySelector('.header-buy-now-btn');
  if (!buyNowBtn) return;

  // 2. UI helpers: spinner controls
  const showButtonSpinner = (btn) => {
    const spinner = btn.querySelector('.loading__spinner');
    if (!spinner) return;
    spinner.classList.remove('hidden');
    spinner.setAttribute('aria-hidden', 'false');
  };

  const hideButtonSpinner = (btn) => {
    const spinner = btn.querySelector('.loading__spinner');
    if (!spinner) return;
    spinner.classList.add('hidden');
    spinner.setAttribute('aria-hidden', 'true');
  };

  // 3. UI helpers: button lock/unlock (prevents double click/tap)
  const lockButton = (btn) => {
    btn.dataset.locked = 'true';
    btn.setAttribute('aria-disabled', 'true');
    btn.setAttribute('tabindex', '-1');
    btn.classList.add('is-disabled');
  };

  const unlockButton = (btn) => {
    delete btn.dataset.locked;
    btn.removeAttribute('aria-disabled');
    btn.removeAttribute('tabindex');
    btn.classList.remove('is-disabled');
  };

  // 4. Core action: add variant to cart via Shopify AJAX API
  const addVariantToCart = async ({ id, quantity }) => {
    const res = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id, quantity }),
    });

    const data = await res.json().catch(() => ({}));
    if (!res.ok) throw new Error(data?.description || data?.message || 'Add to cart failed');
    return data;
  };

  // 5. Wire up events: click handler for header Buy Now button
  buyNowBtn.addEventListener('click', async (e) => {
    // 5.1 Prevent default <a> navigation
    e.preventDefault();

    // 5.2 Guard against double click/tap
    if (buyNowBtn.dataset.locked === 'true') return;

    // 5.3 Resolve variant + quantity (static for header CTA)
    // Future-ready: swap to buyNowBtn.dataset.variantId if you add data-variant-id=""
    const variantId = 43003230748761;
    const quantity = 1;

    // 5.4 Enter loading state (a11y + UI)
    lockButton(buyNowBtn);
    buyNowBtn.setAttribute('aria-busy', 'true');
    buyNowBtn.classList.add('is-loading');
    showButtonSpinner(buyNowBtn);

    try {
      // 5.5 Add item to cart
      await addVariantToCart({ id: variantId, quantity });

      // 5.6 Redirect straight to checkout
      window.location.href = '/checkout';
    } catch (err) {
      console.warn(err?.message || err);

      // 5.7 Error handling: restore button so user can retry
      buyNowBtn.removeAttribute('aria-busy');
      buyNowBtn.classList.remove('is-loading');
      hideButtonSpinner(buyNowBtn);
      unlockButton(buyNowBtn);
    }
  });
});